import React, { useState } from "react";
import PivotTableUI from "react-pivottable/PivotTableUI";
import "./css/Pivot.css";
import { aggregators, renderers } from "react-pivottable/Utilities";
import TableRenderers from "react-pivottable/TableRenderers";
import Plot from "react-plotly.js";
import createPlotlyRenderers from "react-pivottable/PlotlyRenderers";

export function ReactPivot({ data }) {
  const PlotlyRenderers = createPlotlyRenderers(Plot);
  const [state, setState] = useState([]);

  return (
    <PivotTableUI
      data={data}
      aggregatorName="Integer Sum"
      rendererName="Table Col Heatmap"
      renderers={Object.assign({}, TableRenderers, PlotlyRenderers)}
      onChange={(s) => {
        setState(s);
      }}
      {...state}
    />
  );
}
